import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetSolicitudPagoDirectoByID = {
  status: number | null;
  statusText: string | null;
};

const useGetSolicitudPagoDirectoByID = () => {
  const [loadingGetSolicitudPagoDirectoByID, setLoadingGetSolicitudPagoDirectoByID] = useState(false);
  const [successGetSolicitudPagoDirectoByID, setSuccessGetSolicitudPagoDirectoByID] = useState(false);
  const [errorGetSolicitudPagoDirectoByID, setErrorGetSolicitudPagoDirectoByID] = useState<any>(null);
  const [dataGetSolicitudPagoDirectoByID, setDataSolicitudPagoDirecto] = useState<any>(null);

  const [statusGetSolicitudPagoDirectoByID, setStatusGetSolicitudPagoDirectoByID] =
    useState<StatusGetSolicitudPagoDirectoByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // GET
  const getSolicitudPagoDirectoByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetSolicitudPagoDirectoByID(true);
    setSuccessGetSolicitudPagoDirectoByID(false);
    setErrorGetSolicitudPagoDirectoByID(null);

    try {
      const res = await apiRecord.getSolicitudPagoDirectoIncapacidadTemporalByID(
        userId,
        prestacionId,
        id
      );

      setStatusGetSolicitudPagoDirectoByID({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetSolicitudPagoDirectoByID(true);
      setDataSolicitudPagoDirecto(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {
      const responseData = err?.response?.data;
      const backendMessage =
        (typeof responseData === "string" ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        err?.response?.statusText ||
        err?.message ||
        "Error";

      setStatusGetSolicitudPagoDirectoByID({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetSolicitudPagoDirectoByID(err);
      console.error("Error en getSolicitudPagoDirectoByID:", err);

      throw err;

    } finally {
      setLoadingGetSolicitudPagoDirectoByID(false);
    }
  };

  return {
    getSolicitudPagoDirectoByID,
    loadingGetSolicitudPagoDirectoByID,
    successGetSolicitudPagoDirectoByID,
    errorGetSolicitudPagoDirectoByID,
    dataGetSolicitudPagoDirectoByID,
    statusGetSolicitudPagoDirectoByID
  };
};

export default useGetSolicitudPagoDirectoByID;
